export enum LoginActionTypes {

  // SET REFRESH TIME
  SET_REFRESH_TOKEN_TIME = "@@LOGIN/SET_REFRESH_TOKEN_TIME",

  // GET REFRESH TOKEN
  GET_REFRESH_TOKEN_TIME = "@@LOGIN/GET_REFRESH_TOKEN_TIME",
}